export default function Logo({ className = 'h-16' }) {
  return (
    <div className={`flex items-center ${className}`} aria-label="JM Travel">
      <img
        src="/assets/jm-travel-logo.png"
        alt="JM Travel"
        className="h-full w-auto object-contain"
        draggable="false"
      />
    </div>
  );
}
